function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMovie60 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
}, props), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-148 -207)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60,
  "data-name": "Rectangle 369",
  rx: 30,
  style: {
    fill: "#fff",
    opacity: 0.9
  },
  transform: "translate(148 207)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.132 1.519a1 1 0 0 1 1.736 0L23.145 19.5a1 1 0 0 1-.868 1.5H1.723a1 1 0 0 1-.868-1.5z",
  style: {
    fill: "#333"
  },
  transform: "rotate(90 -17 208)"
})));
export default SvgIconMovie60;